export const ASSETS_SOURCE = {
  ASSETS: 'assets-source',
  ASSETS_CIRCLE_PROXIMITY: 'assets-active-circle-proximity',
};

export const ASSETS_LAYER = {
  ASSETS: 'assets-layer',
  ASSETS_ACTIVE: 'assets-active-layer',
  ASSETS_CIRCLE_PROXIMITY: 'assets-active-circle-proximity',
};

export const TextColor = {
  Neutral: '#B8B5C4',
};
